export enum LineTerminatorIcon {
    None = "None",
    Start = "Start",
    End = "End",
    Both = "Both"
}